import * as React from 'react';
import { ChooseModelContainer } from '../../../Shared/index';
import { LessonForm as SharedLessonForm } from '../../../Shared/components/lessons/lessonForm';

const ChooseModelWrapper = ({ conceptsFeedback, modelConceptUID, updateModelConcept }) => (
  <ChooseModelContainer
    conceptsFeedback={conceptsFeedback}
    modelConceptUID={modelConceptUID}
    onRemove={() => updateModelConcept(null)}
    onSave={(uid) => updateModelConcept(uid)}
  />
);

const FillInBlankLessonForm: React.FC<any> = (props) => (
  <SharedLessonForm
    {...props}
    ChooseModelComponent={ChooseModelWrapper}
    requiredQuestionType='fillInBlank'
  />
);

export default FillInBlankLessonForm;
